import axios from 'axios'
import { toast } from 'react-toastify'
import config from '../config/environment'

const api = axios.create({
  baseURL: config.ADMIN_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      window.location.href = '/admin/login'
    }
    return Promise.reject(error)
  }
)

export const serviceProviderService = {
  async getProviders() {
    try {
      const response = await api.get('/service-providers')
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to fetch service providers'
      toast.error(errorMessage)
      throw new Error(errorMessage)
    }
  },

  async createProvider(payload) {
    try {
      const response = await api.post('/service-providers', payload)
      toast.success('Service provider created successfully')
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to create service provider'
      toast.error(errorMessage)
      throw new Error(errorMessage)
    }
  },

  async updateProvider(providerCode, payload) {
    try {
      const response = await api.put(`/service-providers/${providerCode}`, payload)
      toast.success('Service provider updated successfully')
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to update service provider'
      toast.error(errorMessage)
      throw new Error(errorMessage)
    }
  },

  async deleteProvider(providerCode) {
    try {
      const response = await api.delete(`/service-providers/${providerCode}`)
      toast.success('Service provider deleted successfully')
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to delete service provider'
      toast.error(errorMessage)
      throw new Error(errorMessage)
    }
  }
}

export default serviceProviderService

